<div class="modal" tabindex="-1" role="dialog" [ngClass]="isModalOpen ? 'open-modal' : 'close-modal'">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content alert-modal">
            <div class="title-body">
                <div class="title-container">
                    <label class="modal-title title"> {{(title | translate) ? (title | translate): title }}</label>
                </div>
                <div class="message-body">
                    <div id="input-checkbox" *ngIf="showCheckbox">
                        <input type="checkbox" value="true" name="checkbox" [(ngModel)]="isChecked">
                    </div>
                    <div class="body"
                        [innerHTML]="(message | translate) ? (message | translate | placeholderReplace: placeholderObject) : message">
                    </div>
                </div>
                <div class="line-seperator">

                </div>
            </div>
            <div class="footer-container">
                <div class="button-region">
                    <button *ngIf="isCancelVisible" type="button" class="delta" data-dismiss="modal"
                        (click)="onCancel()"><span>{{(cancelBtnTitle | translate) ? (cancelBtnTitle | translate):
                            cancelBtnTitle}}</span></button>
                    <button *ngIf="isConfirmVisible && actionBtnTitle" type="button" class="beta" data-dismiss="modal"
                        (click)="onAction()"><span>{{(actionBtnTitle | translate) ? (actionBtnTitle | translate):
                            actionBtnTitle }}</span></button>
                </div>
            </div>
        </div>
    </div>
</div>